import { Button, CircularProgress, ThemeProvider, Tooltip, useTheme } from "@mui/material";
import { greenTheme } from "utils/Themes";

import CheckIcon from '@mui/icons-material/Check';

const AcceptButton = props => {

    const {
        title = "",
        isLoading = false,
        ...others
    } = props;

    const theme = useTheme();

    return (
        <ThemeProvider
            theme={greenTheme}
        >
            <Tooltip
                title={title}
                arrow
            >
                <Button
                    color="primary"
                    variant={"contained"}
                    style={{
                        minWidth: "2.2em",
                        minHeight: "2.2em",
                        margin: theme.spacing(.5),
                        padding: 0
                    }}
                    {...others}
                >
                    {isLoading ? (
                        <CircularProgress
                            size={20}
                            style={{
                                color: "white"
                            }}
                        />
                    ) : (
                        <CheckIcon
                            fontSize={"small"}
                        />
                    )}
                </Button>
            </Tooltip>
        </ThemeProvider>
    );
}

export default AcceptButton;